const staticRouter = [
  {
    path: '/static/openbox',
    component: () => import('@/views/openbox'),
    name: 'Openbox',
    meta: { title: 'BabyAlpha 开箱指南' }
  },
  {
    path: '/static/hanger',
    component: () => import('@/views/hanger'),
    name: 'Hanger',
    meta: { title: 'BabyAlpha 开机指南' }
  },
  {
    path: '/static/foreign/hanger',
    component: () => import('@/views/foreign/hanger'),
    name: 'ForeignHanger',
    meta: { title: 'BabyAlpha Power On Guide' }
  },
  {
    path: '/static/classroom',
    component: () => import('@/views/robotClassroom'),
    name: 'Classroom',
    meta: { title: '小白课堂' }
  },
  {
    path: '/static/classroomDetail',
    component: () => import('@/views/robotClassroom/classroomDetail'),
    name: 'ClassroomDetail',
    meta: { title: '小白课堂' }
  },
  {
    path: '/static/developer/powerOn',
    component: () => import('@/views/dev/powerOn'),
    name: 'DeveloperPowerOn',
    meta: { title: '开发者版本开发视频' }
  },
  {
    path: '/static/developer/resources',
    component: () => import('@/views/dev/resources'),
    name: 'DeveloperResources',
    meta: { title: '开发者版本资源下载' }
  },
  {
    path: '/foreign/developer/powerOn',
    component: () => import('@/views/foreign/powerOn'),
    name: 'DeveloperPowerOnForeign',
    meta: { title: 'Developer Edition Tutorial Video' }
  },
  {
    path: '/foreign/developer/resources',
    component: () => import('@/views/foreign/resources'),
    name: 'DeveloperResourcesForeign',
    meta: { title: 'Developer Edition Documentation Download' }
  }
]
export default staticRouter



// WEBPACK FOOTER //
// ./src/router/modules/static.js